/* 🤖 this file was generated by svg-to-ts*/
export const icoYoutube: {
  name: 'youtube';
  data: string;
} = {
  name: 'youtube',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.995 9.934a7.669 7.669 0 00-.826-3.738 2.655 2.655 0 00-1.563-.905 71.463 71.463 0 00-7.604-.28 71.545 71.545 0 00-7.577.271c-.498.09-.96.323-1.327.67-.817.751-.908 2.036-1 3.122a43.54 43.54 0 000 5.865c.027.611.119 1.218.273 1.81.11.457.332.88.645 1.23.37.366.842.612 1.354.707 1.959.24 3.932.34 5.905.299 3.18.045 5.97 0 9.267-.254a2.62 2.62 0 001.39-.706c.255-.253.445-.564.555-.905a9.544 9.544 0 00.472-3.077c.036-.507.036-3.566.036-4.109zM9.948 14.586V8.984l5.379 2.814c-1.508.833-3.498 1.774-5.379 2.788z" fill="#909090"/></svg>`
};
